import { render, staticRenderFns } from "./AppSlideshow.vue?vue&type=template&id=a64a1c54&scoped=true&"
import script from "./AppSlideshow.vue?vue&type=script&lang=ts&"
export * from "./AppSlideshow.vue?vue&type=script&lang=ts&"
import style0 from "./AppSlideshow.vue?vue&type=style&index=0&id=a64a1c54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64a1c54",
  null
  
)

export default component.exports